import { Button } from "@/components/ui/button"

type ReportNotFoundProps = {
	onNewReport: () => void
}
export function ReportNotFound(props: ReportNotFoundProps) {
	return (
		<div className="h-screen w-screen flex flex-col items-center justify-center gap-4">
			<h1 className="text-2xl font-bold">Report Not Found</h1>
			<p className="text-muted-foreground">
				The report you're looking for doesn't exist.
			</p>
			<Button onClick={props.onNewReport}>Create New Report</Button>
		</div>
	)
}
